/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Flickity marks non-selected carousel slides with aria-hidden="true" but
  // does not touch the focusability of the slide itself or its contents,
  // which trips the "aria-hidden elements contain focusable descendants"
  // check. This keeps tabindex in sync with Flickity's own aria-hidden state
  // for every carousel slide ([data-slide]) on the site -- including the
  // slide element itself when it is a focusable link (e.g. the product
  // grid card <a>), not only its descendants.
  var FOCUSABLE_SELECTOR = 'a[href], button, input, select, textarea, [tabindex]';

  function applyFocusState(el, hidden) {
    if (hidden) {
      if (!el.hasAttribute('data-a11y-tabindex')) {
        el.setAttribute('data-a11y-tabindex', el.getAttribute('tabindex') || '');
      }
      el.setAttribute('tabindex', '-1');
    } else if (el.hasAttribute('data-a11y-tabindex')) {
      var previous = el.getAttribute('data-a11y-tabindex');
      if (previous) {
        el.setAttribute('tabindex', previous);
      } else {
        el.removeAttribute('tabindex');
      }
      el.removeAttribute('data-a11y-tabindex');
    }
  }

  function syncSlideFocus(slide) {
    var hidden = slide.getAttribute('aria-hidden') === 'true';

    // The slide itself may be the focusable element (e.g. the product
    // grid card is now a single <a>), not just something inside it.
    if (slide.matches(FOCUSABLE_SELECTOR)) {
      applyFocusState(slide, hidden);
    }

    var focusables = slide.querySelectorAll(FOCUSABLE_SELECTOR);
    focusables.forEach(function (el) {
      applyFocusState(el, hidden);
    });
  }

  document.querySelectorAll('[data-slide]').forEach(syncSlideFocus);

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.attributeName === 'aria-hidden' && mutation.target.hasAttribute('data-slide')) {
        syncSlideFocus(mutation.target);
      }
    });
  }).observe(document.body, {
    attributes: true,
    attributeFilter: ['aria-hidden'],
    subtree: true
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
